import React, { useEffect } from "react";
import { connect } from "react-redux";
import { syncLoyaltyRewards, deleteReward } from "../../actions/loyalty";
import RewardCard from "./RewardCard";

const LoyaltyRewardsDisplay = ({ syncLoyaltyRewards, loyalty, deleteReward }) => {
	const { rewards } = loyalty;
	const handleClick = ({ _id }) => {
		if (!window.confirm("Confirme para eliminar el premio")) return;
		deleteReward(_id, syncLoyaltyRewards);
	};

	useEffect(() => {
		syncLoyaltyRewards();
	}, [syncLoyaltyRewards]);

	return (
		<div
			style={{
				display: "flex",
				alignItems: "flex-start",
				flexWrap: "wrap",
				margin: "auto",
				width: "fit-content",
				justifyContent: "center",
			}}
		>
			{rewards.map((reward) => {
				return <RewardCard key={reward._id} data={reward} id={reward.id} handleClick={() => handleClick(reward)} />;
			})}
		</div>
	);
};

const mapStateToProps = ({ loyalty }) => {
	return { loyalty };
};

export default connect(mapStateToProps, { syncLoyaltyRewards, deleteReward })(LoyaltyRewardsDisplay);
